<template>
  <div class="container">
    <div class="content py-4">
    <h3 class="py-5">數位簽名執行錯誤，請聯繫服務提供者。 <br>
      <br>
      Digital signature execution error, please contact the service provider.</h3>
    </div>
	</div>
</template>

<script>

export default {
  name: 'failedView',
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-check{
  font-size: 20px;
  display: inline-block;
  margin-bottom: 16px;
}
#signature{
  width: 100%;
  
  border: solid 3px #9fa9b8f1;
  border-radius: 5px;
  background: rgba(240, 248, 255, 0.916)
  /* background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box; */
}
.content{
	/* background-color: #def0f3; */
}
/* h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>
